/**
 * ReportsHarvestInspectionsPersonFirstName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionsPersonValue } from '../../services/reportsHarvestInspectionsPeople/selectors';

interface Props {
    personFirstName?: ?string;
}

export class ReportsHarvestInspectionsPersonFirstName extends React.PureComponent<Props> {
    render() {
        const { personFirstName } = this.props;
        if (!personFirstName) return null;
        return personFirstName;
    }
}

const mapStateToProps = createStructuredSelector({
    personFirstName: makeSelectReportsHarvestInspectionsPersonValue(
        'personFirstName'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionsPersonFirstName
);
